import { AddIcon } from "assets/icons";
import Button from "components/BaseWidgets/button";
import Divider from "components/BaseWidgets/divider";
import Modal from "components/BaseWidgets/modal";
import Tag from "components/BaseWidgets/tag";
import { useEffect, useState } from "react";
import "./style.scss";

function PickerModal({
  open,
  onCancel,
  onOk,
  title,
  description,
  selectedTags,
  data,
}) {
  const [tempSelectedTags, setTempSelectedTags] = useState([...selectedTags]);
  const [expandedSections, setExpandedSections] = useState({});

  useEffect(() => {
    setTempSelectedTags([...selectedTags]);
  }, [selectedTags, open]);

  const toggleSectionExpansion = (sectionTitle) => {
    setExpandedSections((prev) => ({
      ...prev,
      [sectionTitle]: !prev[sectionTitle],
    }));
  };

  const handleTagClick = (key) => {
    setTempSelectedTags((prevSelected) =>
      prevSelected.includes(key)
        ? prevSelected.filter((k) => k !== key)
        : [...prevSelected, key],
    );
  };

  const renderTags = (tags, sectionTitle) => {
    const initialItemsCount = 8;
    const showViewMore = tags.length > initialItemsCount;
    const isExpanded = expandedSections[sectionTitle];
    const itemsToShow = isExpanded ? tags : tags.slice(0, initialItemsCount);

    return (
      <div className="selection-tag-wrapper flex flex-col gap-4">
        <div className="flex gap-4 flex-wrap">
          {itemsToShow.map(({ key, label, icon }) => (
            <Tag
              key={key}
              icon={
                icon ? (
                  <span className="emoji-icon">
                    <img src={icon} alt="" />
                  </span>
                ) : null
              }
              isActive={tempSelectedTags.includes(key)}
              onClick={() => handleTagClick(key)}
            >
              {label}
            </Tag>
          ))}
        </div>

        {showViewMore && (
          <Button
            icon={<AddIcon />}
            variant="custom"
            className="view-more-btn"
            onClick={() => toggleSectionExpansion(sectionTitle)}
          >
            {isExpanded ? "View less" : "View more"}
          </Button>
        )}
      </div>
    );
  };

  return (
    <Modal
      isOpen={open}
      className="interests-modal-wrapper"
      onCancel={onCancel}
      title=""
      width={758}
      footer={null}
      closable
    >
      <div className="modal-content">
        <h2 className="modal-title">{title}</h2>
        <p className="modal-description mt-3">{description}</p>

        <div className="content-wrapper w-full">
          {Object.entries(data).map(([sectionTitle, tags]) => (
            <div
              key={sectionTitle}
              className="content-item flex flex-col items-start gap-2 w-full"
            >
              <label className="input-label w-full">{sectionTitle}</label>
              {renderTags(tags, sectionTitle)}
              <Divider className="content-divider" />
            </div>
          ))}
        </div>

        <Button className="modal-btn" onClick={() => onOk(tempSelectedTags)}>
          Select
        </Button>
      </div>
    </Modal>
  );
}

export default PickerModal;
